console.log('-RevoTracking JS Loaded-')



clean = (text) => {
    text = text.trim()
    text = text.toLowerCase()
    return text;
}

infoReset = () => {
    document.getElementById("error_sys").style.display = "none";
    document.getElementById("error_order").style.display = "none";
    document.getElementById("error_auth").style.display = "none";
    document.getElementById("error_empty").style.display = "none";
    document.getElementById("error_payment").style.display = "none";
    document.getElementById("pend").style.display = "none";
    document.getElementById("confirm").style.display = "none";
    document.getElementById("int_full").style.display = "none";
    document.getElementById("detalle").innerHTML = ''
}


getAuth = async (form) => {
    const country = 'cl'
    const store = 'rcl'
    const test = false
    const domain = test ? 'http://localhost:3000/' : 'https://api.revocommerce.cl/';
    infoReset();
    console.log(form.order.value)
    console.log(form.mail.value)
    const order = clean(form.order.value)
    const mail = clean(form.mail.value)

    if (order.length > 0 & mail.length > 0) {

        const query_addr = domain + 'auth-' + country;
        const redir_addr = domain + 'auth-' + country;
        const redir_url = redir_addr + '?order=' + order + '&mail=' + mail + '&store=' + store + "&show=true";
        const query_url = query_addr + '?order=' + order + '&mail=' + mail + '&store=' + store;
        console.log(query_url)
        var response = await fetch(query_url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
            .catch(e => {
                console.error(e)
            })
        var status = response.status;
        console.log(status)

        // CASO: EXTERNA-FULLFILED
        if (status == 'auth_ext') {
            console.log('ext_full')
            renderTrack(3)

            if (country == "cl") {
                console.log('ext_full_cl')
                console.log('renderboton_cl')
                renderBotonURL(redir_url)

            }
            if (country == "co") {
                console.log('ext_full_co')
                console.log('renderboton_co')
                const trackingNumber = response.trackingNumber;
                console.log(trackingNumber)
                renderBotonCO(trackingNumber)
            }
        }
        // CASO: INTERNA - FULFILLED
        else if (status == 'auth_int') {
            console.log('int')
            document.getElementById("int_full").style.display = "block";
            renderTrack(3)
        }

        // CASO: ENTREGALO - FULFILLED
        else if (status == 'auth_entregalo') {
            console.log('entregalo_co')
            const trackingUrl = response.trackingUrl;
            console.log(trackingUrl)
            renderBotonURL(trackingUrl)
            renderTrack(3)
        }
        // CASO: UNFULFILLED - SAME DAY
        else if (status == 'auth_pend0') {
            console.log('pend0')
            document.getElementById("confirm").style.display = "block";
            renderTrack(1)

        }
        // CASO: UNFULFILLED - NEXT DAY
        else if (status == 'auth_pend1') {
            console.log('pend1')
            document.getElementById("pend").style.display = "block";
            renderTrack(2)
        }


        // CASO: SIN PAGAR/COD
        else if (status == 'auth_pay') {
            console.log('pay')
            document.getElementById("error_payment").style.display = "block";


        }
        // CASO: ERROR API SHOPIFY
        else if (status == 'auth_error1') {
            document.getElementById("error_sys").style.display = "block";
            console.log('auth_error1')

        }
        // CASO: ERROR AUTENTICACION
        else if (status == 'auth_fail') {
            document.getElementById("error_auth").style.display = "block";

        }
        // CASO: ERROR ORDEN NO EXISTE
        else if (status == 'auth_error2') {
            document.getElementById("error_order").style.display = "block";
            console.log('error_id')

        }
        // CASO: ERROR DESCONOCIDO
        else {
            document.getElementById("error_sys").style.display = "block";
            console.log('error_unknown')

        }


    }
    // CASO: DATOS INCOMPLETOS
    else {
        document.getElementById("error_empty").style.display = "block";
        console.log('error_empty')
    }

}
autofill = () => {
    console.log('Autofill - Start')
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    console.log(urlParams)
    has_order = urlParams.has('order');
    has_mail = urlParams.has('mail');

    if (has_order & has_mail) {
        const order = urlParams.get('order')
        const mail = urlParams.get('mail')
        document.getElementById('order').value = order
        document.getElementById('mail').value = mail
        form = document.getElementById("tracking")
        getAuth(form);
    }
}
renderTrack = (status) => {
    let step1 = document.getElementById("step1")
    let step2 = document.getElementById("step2")
    let step3 = document.getElementById("step3")
    let span1 = document.createElement("span");
    let span2 = document.createElement("span");
    let span3 = document.createElement("span");
    let svg_check = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>'


    if (status == 1) {
        console.log('Track1')
        step1.classList.add("step-completed");
        step1.prepend(span1);
        let child = step1.firstChild
        child.classList.add("step-indicator");
        child.innerHTML += svg_check
    }
    if (status == 2) {
        console.log('Track2')
        step1.classList.add("step-completed");
        step1.prepend(span1);
        let child = step1.firstChild
        child.classList.add("step-indicator");
        child.innerHTML += svg_check
        step2.classList.add("step-active");
    } else if (status == 3) {
        console.log('Track3')
        step1.classList.add("step-completed");
        step1.prepend(span1);
        let child = step1.firstChild
        child.classList.add("step-indicator");
        child.innerHTML += svg_check
        step2.classList.add("step-completed");
        step2.prepend(span2);
        let child2 = step2.firstChild
        child2.classList.add("step-indicator");
        child2.innerHTML += svg_check
        step3.classList.add("step-completed");
        step3.prepend(span3);
        let child3 = step3.firstChild
        child3.classList.add("step-indicator");
        child3.innerHTML += svg_check

    }

    document.getElementById("steps").style.display = "block";
}

renderBotonURL = (redir_url) => {
    let detalle = document.getElementById("detalle");
    let boton = document.createElement("button")
    boton.type = 'button'
    boton.innerHTML = "Ver seguimiento detallado";
    boton.addEventListener('click',
        function () {
            redir(redir_url);
        }
    )
    detalle.appendChild(boton);
};

renderBotonCO = (trackingNumber) => {

    let detalle = document.getElementById("detalle");
    let boton = document.createElement("button")
    boton.type = 'button'
    boton.innerHTML = "Ver seguimiento detallado";
    boton.addEventListener('click',
        function () {
            showCoordinadora(trackingNumber);
        }
    )
    detalle.appendChild(boton);
}


redir = (redir_url) => {
    window.location.href = redir_url;
}

showCoordinadora = (trackingNumber) => {
    console.log('showCoordinadora')
    console.log(trackingNumber)
    var url_coordinadora = 'https://www.coordinadora.com/portafolio-de-servicios/servicios-en-linea/rastrear-guias/';
    var form = $('<form hidden action="' + url_coordinadora + '" method="post">' +
        '<input type="text" name="coor_guia" value="' + trackingNumber + '" />' +
        '<input type="text" name="coor_guia_home" value="true" />' +
        '</form>');
    alert("Serás llevado a la página de seguimiento de Coordinadora. Para ver la información de tu pedido desplazate hacia abajo.");
    $('body').append(form);
    form.submit();
}
